import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Board, Rating, FirstGame, Modal, Information } from "../../components";
import { StatusGame } from "../../components/Rating/Rating.interface";
import { AppDispatch, RootState } from "../../redux/store";
import convertSecToTime from "../../Utils/convertSecToTime";
import {
  countTime,
  setCaptionInformation,
  setCurrentIndexWord,
  setHelper,
  setIsEnd,
  setIsFirstGame,
  setIsInformation,
  setIsResults,
  setIsStart,
  setMessageInformation,
  setSearchWord,
  setTheme,
  setWords,
} from "../../redux/slices/game/gameSlice";
import styles from "./Main.module.scss";
import { LS_CONFIG, LS_NAME } from "../../Static/consts";
import { IJson } from "../../entities/IJson";
import { wordIntoLetters } from "../../Utils/wordIntoLetters";
import { ILsConfig } from "../../entities/ILsConfig";
import { Results } from "../../components/Results/Results";

export const Main: React.FC = () => {
  const {
    isEnd,
    isFirstGame,
    isStart,
    isWin,
    searchWord,
    time,
    helper,
    theme,
    isInformation,
    messageInformation,
    captionInformation,
    isResults,
  } = useSelector((state: RootState) => state.game);
  const dispatch = useDispatch<AppDispatch>();
  const timer = useRef<NodeJS.Timer>();
  const [answerWords, setAnswerWords] = useState<string[]>([]);

  useEffect(() => {
    (async () => {
      fetch("/words.json")
        .then(async (res) => {
          const words: IJson[] = await res.json();
          dispatch(setWords(words));
          const lsData = localStorage.getItem(LS_NAME);
          if (lsData) {
            const lsAnswerWords = JSON.parse(lsData);
            const countAnswerWord = lsAnswerWords.length;
            setAnswerWords(lsAnswerWords.map((item: IJson) => item.word));
            if (countAnswerWord < words.length) {
              dispatch(
                setSearchWord(wordIntoLetters(words[countAnswerWord].word))
              );
              dispatch(setTheme(words[countAnswerWord].theme));
              dispatch(setHelper(words[countAnswerWord].help));
              dispatch(setCurrentIndexWord(countAnswerWord));
            } else {
              dispatch(setIsResults(true));
              return;
            }
          } else {
            dispatch(setSearchWord(wordIntoLetters(words[0].word)));
            dispatch(setTheme(words[0].theme));
            dispatch(setHelper(words[0].help));
          }
          const lsConfig = localStorage.getItem(LS_CONFIG);
          if (lsConfig) {
            const jsonLsConfig: ILsConfig = JSON.parse(lsConfig);
            if (!jsonLsConfig.isFirstGame) {
              localStorage.setItem(
                LS_CONFIG,
                JSON.stringify({ isFirstGame: true })
              );
              onStartGame();
            } else {
              dispatch(setIsFirstGame(true));
            }
          } else {
            dispatch(setIsFirstGame(true));
          }
        })
        .catch(() => {
          dispatch(setCaptionInformation("Ошибка"));
          dispatch(setMessageInformation("Ненастроенн источник слов"));
          dispatch(setIsInformation(true));
        });
    })();
  }, []);

  useEffect(() => {
    if (isStart && time === 0) {
      timer.current = setInterval(() => {
        dispatch(countTime());
      }, 1000);
    }
  }, [isStart, time]);

  useEffect(() => {
    if (isEnd || isWin) {
      clearInterval(timer.current);
    }
  }, [isEnd, isWin]);

  const onStartGame = () => {
    dispatch(setIsFirstGame(false));
    dispatch(setIsStart(true));
  };

  const onShowHelper = () => {
    dispatch(setMessageInformation(helper));
    dispatch(setCaptionInformation("Подсказка"));
    dispatch(setIsInformation(true));
  };

  return (
    <>
      <div className={styles.mainWrap}>
        <div className={styles.main}>
          
            <div className={styles.theme}>
              <div className={styles.themeWord}>
                {theme ? `Тема: «${theme}»` : ""}
              </div>
            </div>
            <div className={styles.timer}>{convertSecToTime(time)}</div>
            <div className={styles.themeWord}>
              {helper ? (
                <div className={styles.theme}>
                  Подсказка:{" "}
                  <div className={styles.helper} onClick={onShowHelper}>
                    ?
                  </div>
                </div>
              ) : null}
            </div>
            <div></div>
          
          </div>
          <div className={styles.main}>
          <div className={styles.mainBoard}>
            <Board />
          </div>
          <div>
            {answerWords.map((word) => (
              <div className={styles.word} key={word}>{word}</div>
            ))}
          </div>
        </div>
      </div>
      <Modal isShow={isEnd} onClose={() => {}}>
        <Rating
          status={isWin ? StatusGame.WIN : StatusGame.LOSS}
          searchWord={searchWord}
          time={time}
          onClose={() => {
            dispatch(setIsEnd(false));
          }}
        />
      </Modal>
      <Modal isShow={isFirstGame} onClose={() => {}}>
        <FirstGame onClose={onStartGame} onStart={onStartGame} />
      </Modal>
      <Modal isShow={isInformation} onClose={() => {}}>
        <Information
          message={messageInformation}
          onClose={() => {
            dispatch(setIsInformation(!isInformation));
          }}
          caption={captionInformation}
        />
      </Modal>
      <Modal isShow={isResults} onClose={() => {}}>
        <Results
          onClose={() => {
            // dispatch(setIsResults(false));
          }}
        />
      </Modal>
    </>
  );
};
